/** ***********
*
* <kpi-common.ts v1.0>
*
* Copyright (c) 2022 AIRBUS OPERATIONS
*
* Contributors:
*  GARY Adrien (NG635E8) [adrien.gary.external@airbus.com]
*
* All rights reserved.
**************/


import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class CommonKPIService {

    /**
     * Get the colors of a kpi depending on params
     * @param indexG Zone name
     * @param dataG Zone data
     * @param indexZ1 First zone index
     * @param indexZ2 Second zone index
     * @returns Object (preparing chart data)
     */
    public getDatasetAndColour(
      indexG: string,
      dataG: { y: number; label: string; name: string; }[],
      indexZ1: number,
      indexZ2: number,
    ) {
        const colorsPaired12tab = [
            ['#0D47A1', '#1565C0', '#039BE5', '#26C6DA'],
            ['#1A237E', '#3F51B5', '#5C6BC0', '#9FA8DA'],
            ['#558B2F', '#7CB342', '#8BC34A', '#9CCC65'],
            ['#1B5E20', '#2E7D32', '#388E3C', '#66BB6A'],
            ['#880E4F', '#D81B60', '#EC407A', '#F48FB1'],
            ['#B71C1C', '#E53935', '#E57373', '#EF9A9A'],
            ['#F57F17', '#FBC02D', '#FFEB3B', '#FFF176'],
            ['#E65100', '#FFA000', '#FFB74D', '#FFCC80'],
            ['#4A148C', '#6A1B9A', '#8E24AA', '#BA68C8'],
            ['#3E2723', '#5D4037', '#8D6E63', '#A1887F']
        ];

        let colorToUse = colorsPaired12tab[indexZ1 % colorsPaired12tab.length][0];
        if (indexZ2 !== -1) {
            colorToUse = colorsPaired12tab[indexZ1 % colorsPaired12tab.length][1 + (indexZ2 % 2)];
        }
        return {
            label: indexG,
            data: dataG.map(({ y }) => +y),
            backgroundColor: colorToUse,
        };
    }

    /**
     * Sort algorythm to sort asset depending on their time cycle, descending order
     * @param originalAssets Array of assets
     */
    public quickSortForAssetsNumberOfLoop(originalAssets, type: string) {
        if (originalAssets.length <= 1) {
            return originalAssets;
        } else {
            const leftArr = [];
            const rightArr = [];
            const newArr = [];
            const pivot = originalAssets[0];      //  Take a pivot value
            const length = originalAssets.length;
            for (let i = 1; i < length; i++) {
                if (originalAssets[i][type] >= pivot[type]) {    // using pivot value start comparing
                    leftArr.push(originalAssets[i]);
                } else {
                    rightArr.push(originalAssets[i]);
                }
            }
            return newArr.concat(this.quickSortForAssetsNumberOfLoop(leftArr, type), pivot, this.quickSortForAssetsNumberOfLoop(rightArr, type)); // array will be                                                                            //returned untill sorting occurs
        }
    }
}
